import { load } from '@/util/router-utils.js'

export default [
  {
    path: 'history',
    redirect: 'history/farms',
    component: load('app/client/farm/history/Index'),
    children: [
      { path: 'farms', component: load('app/client/farm/history/farms/Index') },
      { path: 'ration', component: load('app/client/farm/history/rations/Index') },
      { path: 'groups', component: load('app/client/farm/history/groups/Index') },
      { path: 'animal-types', component: load('app/client/farm/history/animal-types/Index') },
      { path: 'ingredients', component: load('app/client/farm/history/ingredients/Index') },
      { path: 'ingredient-types', component: load('app/client/farm/history/ingredient-types/Index') },
      { path: 'mixers', component: load('app/client/farm/history/mixers/Index') },
      { path: 'stocks', component: load('app/client/farm/history/stocks/Index') },
    ]
  }
]
